import React from 'react';
import PropTypes from 'prop-types';
import { BiConversation } from 'react-icons/bi';
import { VscGraph } from 'react-icons/vsc';
import { HiUserGroup } from 'react-icons/hi';

function Footer({ onThread, onLeaderboards, onCommunity }) {
  return (
    <div className="footer__icon">
      <div className="footer__icon__wrapper">
        <BiConversation onClick={onThread} />
        <p>Threads</p>
      </div>
      <div className="footer__icon__wrapper">
        <VscGraph onClick={onLeaderboards} />
        <p>Leaderboards</p>
      </div>
      <div className="footer__icon__wrapper">
        <HiUserGroup onClick={onCommunity} />
        <p>Communities</p>
      </div>
    </div>
  );
}

Footer.propTypes = {
  onThread: PropTypes.func.isRequired,
  onLeaderboards: PropTypes.func.isRequired,
  onCommunity: PropTypes.func.isRequired,
};

export default Footer;
